import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import axios from '../axios';
import { FaFileAlt, FaSpinner } from 'react-icons/fa';

function Archive() {
  const { user } = useAuth();
  const [sheets, setSheets] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSheets = async () => {
      try {
        const response = await axios.get('/api/archive/sheets', { withCredentials: true });
        const translatedSheets = {
          admin: response.data.admin.map(sheet => ({
            ...sheet,
            name: sheet.name.replace('Admin Metrics', 'Administracija'),
            description: sheet.description.replace('Administrative metrics and statistics for', 'Administrativna statistika za leto')
          })),
          agents: response.data.agents.map(sheet => ({
            ...sheet,
            name: sheet.name.replace('Agent Metrics', 'Statistika Agentov'),
            description: sheet.description.replace('Performance metrics and statistics for all agents', 'Statistika uspešnosti vseh agentov')
          })),
          invoices: response.data.invoices.map(sheet => ({
            ...sheet,
            name: sheet.name.replace('Invoices', 'Računi'),
            description: sheet.description.replace('Invoice records for', 'Evidenca računov za leto')
          })),
          other: response.data.other.map(sheet => {
            if (sheet.name === 'StojaCheck') {
              return {
                ...sheet,
                description: 'Podatki in evidenca sistema StojaCheck'
              };
            }
            if (sheet.name === 'Absences') {
              return {
                ...sheet,
                name: 'Odsotnosti',
                description: 'Evidenca odsotnosti zaposlenih'
              };
            }
            return sheet;
          })
        };
        setSheets(translatedSheets);
        setError(null);
      } catch (err) {
        setError(err.response?.data?.error || 'Napaka pri pridobivanju dokumentov');
      } finally {
        setIsLoading(false);
      }
    };

    if (user && (user.role === 'manager' || user.role === 'owner')) {
      fetchSheets();
    } else {
      setError('Dostop zavrnjen. Samo managerji in lastniki lahko dostopajo do te strani.');
      setIsLoading(false);
    }
  }, [user]);

  const openSheet = (url) => {
    window.open(url, '_blank');
  };

  const renderSheetSection = (title, items) => {
    if (!items || items.length === 0) return null;

    return (
      <div className="mb-8">
        <h2 className="text-2xl font-bold mb-4 text-gray-800">{title}</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((item, index) => (
            <div
              key={index}
              className="bg-white p-4 rounded-lg shadow-md hover:shadow-lg transition-shadow cursor-pointer"
              onClick={() => openSheet(item.url)}
            >
              <div className="flex items-center space-x-3">
                <FaFileAlt className="text-blue-500 text-xl" />
                <div>
                  <h3 className="font-semibold text-gray-800">{item.name}</h3>
                  <p className="text-sm text-gray-600">{item.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  if (isLoading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <FaSpinner className="animate-spin text-4xl text-blue-500" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen p-8">
        <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4" role="alert">
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <h1 className="text-3xl font-bold mb-8 text-gray-900">Arhiv Dokumentov</h1>
      
      {renderSheetSection('Administracija', sheets.admin)}
      {renderSheetSection('Statistika Agentov', sheets.agents)}
      {renderSheetSection('Računi', sheets.invoices)}
      {renderSheetSection('Ostali Dokumenti', sheets.other)}
    </div>
  );
}

export default Archive;
